import { AppBar, Toolbar, Button, CardMedia, Typography } from '@material-ui/core';
import { appUserContext, authContext } from 'helpers/services';
import { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import UserMenu from './UserMenu';
import AdminMenu from './AdminMenu';


let NavBar = () => {
    let { isAuthorized, currentUser } = useContext(appUserContext);
    let authService = useContext(authContext);

    return (
        <AppBar elevation={0} position="sticky">
            <Toolbar variant="dense">
                <RouterLink to="/">
                    <CardMedia
                        component="img"
                        src="/images/Videndum_Media_Solutions_Logo_White.svg"
                        height={56}
                    />
                </RouterLink>
                {process.env.REACT_APP_ENV === "staging" &&
                    <Typography>
                        <b>staging env.</b>
                    </Typography>
                }
                {authService.isLoading === false && authService.isAuthenticated === true &&
                    <>
                        <div style={{ flexGrow: 1 }}>
                            {isAuthorized && <Button type="link" component={RouterLink} to="/">Tickets</Button>}
                        </div>
                        <div style={{ display: 'flex' }}>
                            {isAuthorized && currentUser?.canViewAdminArea && <AdminMenu />}
                            <UserMenu />
                        </div>
                    </>
                }
            </Toolbar>
        </AppBar >
    )
}

export default NavBar;